import type { JSX } from 'react';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Triggers the browser print dialog so the certificate can be saved as a PDF.
 */
export function DownloadPdfButton(): JSX.Element {
  return (
    <Button variant="outline" size="sm" className="print:hidden" onClick={() => window.print()}>
      <Download aria-hidden="true" />
      Download PDF
    </Button>
  );
}
